
/**
 * Cache to register leave restriction rules for the current user
 * @kind cache
 * @class LeaveRestrictionRules
 * @description Custom lookup cache for LeaveRestrictionRules
 * @usage let lookup = await Grape.cache.get('LeaveRestrictionRules');
 */
export default {
	name: 'LeaveRestrictionRules',
	options: {
		table: 'v_leave_restriction_rules',
		schema: 'savanna',
		limit: 1000000
	}
};
